import { camelCase } from 'lodash';
import * as z from 'zod';

// Makes it possible to auto-camelize strings prior to validation with an enum. This will
// make schema validation a little bit easier/
// For example `CamelizeEnum(z.enum(['coolOption1', 'goodOption2']))` will ensure that
// string values like `COOL OPTION1` are auto camelized to `coolOption1` prior to validation.
// See example usage in `packages/types-iso/__tests__/zod/Enum.test.ts`

export const CamelizeEnum = <T extends z.ZodType<string, any, any>>(schema: T) =>
  z.string().transform(camelCase).pipe(schema);
